import React from 'react';
import PropTypes from 'prop-types';
import { useClientSideMediaQuery } from 'hooks/use-client-side-media-query';
import { BREAKPOINTS } from 'constants/grid';

import styles from 'components/Product/Image/ProductImage.scss';

const ProductImage = ({ name, placement, position, url }) => {
  const isMobile = useClientSideMediaQuery({ maxWidth: BREAKPOINTS.sm });

  if (!url) return null;

  const imageUrl = url.replace('/9/', `/3/`).replace('_9.jpg', `_3.jpg`);
  const loadingPosition = isMobile ? 2 : 12;
  const loading = position > loadingPosition ? 'lazy' : undefined;

  return (
    <picture className={styles[placement]}>
      <source media="(max-width: 543px)" srcSet={url} />
      <img src={imageUrl} alt={name} loading={loading} />
    </picture>
  );
};

ProductImage.displayName = 'ProductImage';

ProductImage.propTypes = {
  name: PropTypes.string,
  placement: PropTypes.string,
  position: PropTypes.number,
  url: PropTypes.string.isRequired,
};

export default ProductImage;
